import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/images/avatars/ss_logo.png"
      {...props}
      style={{
        height: "40px"
      }}
    />
  );
};

export default Logo;
